
import { useI18n } from '../utils/lni18n';
import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { Outlet, useParams } from 'react-router-dom';
import WaitRipple from 'src/components/WaitRipple';
import courseService, { oneCourseatom } from './CourseService';
import { LockReason } from 'src/types';
import CourseComponentHeader from './CourseComponentHeader';

export default function CourseComponent() {

    const { courseId, themeId } = useParams();
    const [course] = useAtom(
        useMemo(() => oneCourseatom(courseId || ""), [courseId]));

    const { languageService: t } = useI18n();


    if (!course) {
        return <WaitRipple />
    }

    const unlock = () => {
        courseService.loadCourse(course.Course.Id, true);
    }

    return <div className="scrollContent scroller" aria-live="polite">

        <div className="card-box big-card-box h-100" aria-live="polite">
            {!themeId &&
                <CourseComponentHeader />
            }

            <div className="card-box-content card-body">

                <Outlet />
            </div>
        </div>
    </div>



}